import { render, staticRenderFns } from "./FacturaIndex.vue?vue&type=template&id=15bb15f3&scoped=true"
import script from "./FacturaIndex.vue?vue&type=script&lang=ts"
export * from "./FacturaIndex.vue?vue&type=script&lang=ts"
import style0 from "./FacturaIndex.vue?vue&type=style&index=0&id=15bb15f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bb15f3",
  null
  
)

export default component.exports